/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from 'react'

/** Common Components */


/** Utilities */
import RenderTabs2 from '../../../../components/ui/tabs/RenderTabs2'
import Affiliates from './features/affiliates/Affiliates'
import Scopes from './features/scopes/Scopes'
import Departments from './features/departments/Departments'
import Specifications from './features/specifications/Specifications'
import { PendingContractContext } from '../../../../utils/context/PendingContractContext'
import Notes from '../../../../common/features/notes/note'
import { NewOwnerType } from '../../../../utils/ENUMS/OwnerTypes'

const EditPendingContractTab = () => {
    const {pendingContractId} = useContext(PendingContractContext);

    const tabs = [

        {
            sMenuItemCaption: "Specifications",
            component: <Specifications/>,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Departments",
            component: <Departments/>,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Scopes",
            component: <Scopes/>,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Notes",
            component:  <Notes plOwnerKey={pendingContractId} plOwnerTypeKey={NewOwnerType.PENDINGCONTRACT} />,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Affiliates",
            component: <Affiliates/>,
            isDynamic: true
        },
        
    ]
    return (
        <div>
            <RenderTabs2 tabs={tabs} />
        </div>

    )
}

export default EditPendingContractTab